import merge from 'deepmerge';
import * as Actions from './FinancialPlanActions';

const defined = obj => obj || {};

const DEFAULT_STATE = {
  isResettingFinancialPlan: false,
  isLoading: false,
};

export default (state = DEFAULT_STATE, action) => {
  const { type } = action;

  switch (type) {
    case Actions.REQUEST_DATA: {
      return {
        ...state,
        isLoading: true,
        currentClientId: action.clientId,
        [action.clientId]: {
          ...defined(state[action.clientId]),
          data: {
            ...defined(defined(state[action.clientId]).data),
            // This will fix ADV-5996
            sequenceNumber: action.sequenceNumber,
          },
        },
      };
    }
    case Actions.RESET_DATA: {
      return {
        ...state,
        currentClientId: action.clientId,
        [action.clientId]: {
          ...defined(state[action.clientId]),
          data: {},
        },
      };
    }
    case Actions.SET_IS_CALIBRATING: {
      return {
        ...state,
        [action.clientId]: {
          ...defined(state[action.clientId]),
          data: {
            ...defined(defined(state[action.clientId]).data),
            IsCalibrating: action.isCalibrating,
            sequenceNumber: action.sequenceNumber,
          },
        },
      };
    }
    case Actions.UPDATE_GOAL_VIEW_STATE: {
      return {
        ...state,
        [action.clientId]: {
          ...defined(state[action.clientId]),
          [action.goalId]: merge(
            defined(defined(state[action.clientId])[action.goalId]),
            action.viewState,
            { arrayMerge: (a, b) => b },
          ),
        },
      };
    }
    case Actions.UPDATE_GOAL_DATA: {
      return {
        ...state,
        [action.clientId]: {
          ...defined(state[action.clientId]),
          data: {
            ...defined(defined(state[action.clientId]).data),
            Goals: [
              ...(defined(defined(state[action.clientId]).data).Goals || []).slice(
                0,
                action.originalGoalIndex,
              ),
              merge(action.originalGoal, action.data, { arrayMerge: (a, b) => b }),
              ...(defined(defined(state[action.clientId]).data).Goals || []).slice(
                action.originalGoalIndex + 1,
              ),
            ],
          },
        },
      };
    }
    case Actions.SET_GOAL_VIEW_STATE: {
      return {
        ...state,
        [action.clientId]: {
          ...defined(state[action.clientId]),
          [action.goalId]: action.viewState,
        },
      };
    }
    case Actions.SET_ERRORS:
      return {
        ...state,
        isLoading: false,
        [action.clientId]: {
          ...defined(state[action.clientId]),
          errors: action.errors,
        },
      };
    case Actions.SET_ERROR_TYPE:
      return {
        ...state,
        [action.clientId]: {
          ...defined(state[action.clientId]),
          errorType: action.errorType,
        },
      };
    case Actions.SET_REACT_CALIBRATION_WIDGET: {
      return {
        ...state,
        [action.clientId]: {
          ...defined(state[action.clientId]),
          calibration: action.calibration,
        },
      };
    }
    case Actions.SET_PLAN_IMPACT_DATA: {
      return {
        ...state,
        [action.clientId]: {
          ...state[action.clientId],
          data: {
            ...defined(state[action.clientId]).data,
            ...action.planImpactData,
          },
          doNotUpdateCalibration: true,
        },
      };
    }
    case Actions.RECEIVE_DATA: {
      return {
        ...state,
        isLoading: false,
        [action.clientId]: {
          isLoading: false,
          ...defined(state[action.clientId]),
          data: action.data,
          doNotUpdateCalibration: action.doNotUpdateCalibration,
        },
      };
    }
    case Actions.START_RESET_FINANCIAL_PLAN: {
      return {
        ...state,
        isResettingFinancialPlan: true,
      };
    }
    case Actions.FINISH_RESET_FINANCIAL_PLAN: {
      return {
        ...state,
        isResettingFinancialPlan: false,
      };
    }
    case Actions.CLEAR_DATA: {
      return DEFAULT_STATE;
    }
    default: {
      return state;
    }
  }
};
